import RoutesMap from "../../route_control/RouteControl"
import { lazy } from "react"

const AddAsset = lazy(() => import("../../pages/assets/asset/AddAsset"))
const UpdateAsset = lazy(() => import("../../pages/assets/asset/UpdateAsset"))
const AssetList = lazy(() => import("../../pages/assets/asset/AssetList"))
const AssetDetails = lazy(() => import("../../pages/assets/asset/AssetDetails"))
const AddAssetIssue = lazy(() => import('../../pages/assets/asset_issue/AddAssetIssue'))
const AssetIssueList = lazy(() => import('../../pages/assets/asset_issue/AssetIssueList'))
const AssetLocation = lazy(() => import("../../pages/assets/asset_location/AssetLocation"))
const AssetLocationDetails = lazy(() => import("../../pages/assets/asset_location/AssetLocationDetails"))
const AddInventory = lazy(() => import("../../pages/assets/inventory/AddInventory"))
const GrnDetails = lazy(() => import("../../pages/assets/asset/GrnDetails"))
const GrnStockList = lazy(() => import("../../pages/assets/grn/GrnStockList"))
const AddAmc = lazy(() => import("../../pages/assets/amc/AddAmc"))
const UpdateAmc = lazy(() => import("../../pages/assets/amc/UpdateAmc"))
const AmcList = lazy(() => import("../../pages/assets/amc/AmcList"))
const AmcDetails = lazy(() => import("../../pages/assets/amc/AmcDetails"))

export const AssetRouteImport = {
    RoutesMap,
    AddAsset,
    UpdateAsset,
    AssetList,
    AddAssetIssue,
    AssetIssueList,
    AssetLocation,
    AssetLocationDetails,
    AssetDetails,
    AddInventory,
    GrnDetails,
    GrnStockList,
    AddAmc,
    UpdateAmc,
    AmcList,
    AmcDetails,
}